module.exports = __webpack_public_path__ + "img/bj2.be92d626.png";